import React, {useState}  from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as ChevronLeft } from '../../assets/icons/chevron-left-icon.svg';
import { ReactComponent as ChevronRight } from '../../assets/icons/chevron-right-icon.svg';
import './Sidebar.css';
import { useAuth } from '../../contexts/AuthContext';
import ExitModal from '../common/ExitModal';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export default function Sidebar({ menuItems, sidebarOpen, onToggleSidebar }) {
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const { logout } = useAuth();

  return (
    <>
      {sidebarOpen && <div className="sidebar-backdrop" onClick={onToggleSidebar} />}
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <button className="sidebar-toggle" onClick={onToggleSidebar}>
          {sidebarOpen ? <ChevronLeft size={28} color='#7CC805' /> : <ChevronRight size={28} color='#7CC805'/>}
        </button>

        <nav className="sidebar-nav custom-scrollbar">
          {menuItems.map((item) =>
            item.id === "exit" ? (
              <button
                key={item.id}
                type="button"
                className="nav-item-bottoms menu-item"
                onClick={() => setIsExitModalOpen(true)}
              >
                <div className="nav-item">
                  <item.icon width={22} height={22} className="nav-icon" />
                  {sidebarOpen && <span className="nav-label">{item.label}</span>}
                </div>
              </button>
            ) : item.disabled ? (
              <div
                key={item.id}
                className="menu-item menu-item-disabled"
                title={item.label}
              >
                <div className="nav-item">
                  <item.icon width={22} height={22} className="nav-icon" />
                  {sidebarOpen && <span className="nav-label">{item.label}</span>}
                </div>
              </div>
            ) : (
              <NavLink
                key={item.id}
                to={item.path}
                onClick={() => { if (isMobile) onToggleSidebar(); }}
                className={`${(item.id === "notifications" || item.id === "exit") ? 'nav-item-bottoms' : ''}`}
              >
                {
                  ({ isActive }) => (
                    <div className={`menu-item ${isActive ? 'menu-item-active' : ''}`}>
                      <div className={`nav-item ${isActive ? 'active' : ''}`}>
                        <item.icon width={22} height={22} className="nav-icon" />
                        {sidebarOpen && <span className="nav-label">{item.label}</span>}
                      </div>
                    </div>
                  )
                }
              </NavLink>
            )
          )}

        </nav>

        {
          isExitModalOpen && <ExitModal closeModal={() => setIsExitModalOpen(false)} logout={async() => await logout()}/>
        }

      </aside>
    </>
  );
}

